<template>
    <div class="pc">
        <HeadTop></HeadTop>
        <div class="n-config-provider">
            <div class="">
                <div data-v-09672a82="" class="topup pc_container">
                    <!-- 视图 -->
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadTop from '@/components/base/head.vue'
export default {
    name: 'videoVue',
    components: {
        HeadTop,
    },
    data() {
        return {
            wallet: {},
            info: {}
        }
    },
    created() {
        this.getInfo()
        this.getWallet()
    },
    methods: {
        getInfo() {
            this.info = this.$common.getInfo()
        },
        getWallet() {
            var hide = this.$message.loading({ content: 'loading...', key: 'msg' })
            let that = this
            this.$api.userWallet.getWallet().then(res => {
                hide()
                if (res.data.length <= 0) {
                    that.$message.error('error')
                    return
                }
                that.wallet = res.data
            })
        }
    }
}
</script>

<style></style>